import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import cn from 'classnames';
import { getAllCertificates } from "../../store/certificateSlice/certificateRequest";
import {
  selectLastCertificatesByCompanyName,
} from "../../store/certificateSlice/certificateSelectors";
import CertificateTable from "../../components/CertificateTable";
import { selectIsUserApproved } from "../../store/userSlice/userSelectors";
import { Grid2 } from "@mui/material";
import SearchInput from "../../components/SearchInput";
import DownloadButton from "../DownloadButton";

import classes from './index.module.scss';
import { formatDate } from "../../helpers/date";
import { getQueryObject } from "../../helpers/urlBuilder";

function filterCompanyList(companyList, search, type, companyId) {
  return companyList
    .map((company) => {
      const filteredProductList = company.productList
        .filter((product) => product.lastRecord && !product.lastRecord.isArchive)
        .filter((product) => !type || product.lastRecord?.certification_program?.id === type)
        .filter((product) => {
          return !search || ~([
            (product?.lastRecord?.certificateNumber || '').toLowerCase(),
            formatDate(product?.lastRecord?.testDate, {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }).replace(/\./ig, '-').toLowerCase(),
            (product?.lastRecord?.status || '').toLowerCase(),
            (product?.product_type?.productTypeName || '').toLowerCase(),
            (product?.productName || '').toLowerCase(),
            (product?.partList || '').toLowerCase(),
            (product?.classification?.classification || '').toLowerCase(),
            (company.name || '').toLowerCase(),
            (product.material?.name || '').toLowerCase(),
          ]).join(' ').indexOf(search.toLowerCase())
        });

      if (filteredProductList.length === 0) {
        return null;
      }

      if (companyId && company?.id !== companyId) {
        return null;
      }

      return {
        ...company,
        productList: filteredProductList,
      }
    })
    .filter(Boolean);
}

const CertificateContainer = ({ type, companyId = 0, clearBoxHeight = false, showCompanyLink = false }) => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const companyList = useSelector(selectLastCertificatesByCompanyName) || [];
  const isApproved = useSelector(selectIsUserApproved);
  const filteredCompanyList = filterCompanyList(companyList, search, type, companyId);
  const isPremium = type === CertificateContainer.TYPES.PREMIUM;

  useEffect(() => {
    dispatch(getAllCertificates());
  }, []);

  return (
    <Grid2
      container
      size={12}
      className={cn(
        {
          [ classes.tableWrapper ]: !clearBoxHeight,
        }
      )}
    >
      <CertificateTable
        companyList={filteredCompanyList}
        isApproved={isApproved}
        isPremium={isPremium}
        showCompanyRow={companyId === 0}
        showCompanyLink={showCompanyLink}
        searchInput={(
          <SearchInput onChange={setSearch} />
        )}
        rightButton={(
          <DownloadButton companyId={companyId} />
        )}
      />
    </Grid2>
  );
}

CertificateContainer.TYPES = {
  PREMIUM: 2,
  APPROVAL: 1,
  ALL: 0,
}

export default CertificateContainer;